import React from "react";
import Moment from "moment";
import _ from "lodash";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import DateFnsUtils from "@date-io/moment";
import { MuiPickersUtilsProvider, KeyboardDateTimePicker } from "@material-ui/pickers";

export default class Promotion extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,

      // Dados para o formulário
      name: "",
      discountAmount: 0,
      startDate: null,
      endDate: null,
      status: 0,

      // Dados auxiliares
      id: props.id,
      products: [],
      applePricePoints: [],
      selectedProductPrice: null,
      applePromotionPricePointId: "",
      originalApplePricePointId: "",
      productId: "",
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  getIdFromPath = () => {
    const pathSplit = this.props.id.location.pathname.split("/");
    return pathSplit[pathSplit.length - 1];
  };

  fetchData = async () => {
    this.setState({ loading: true });
    try {
      const promotionResponse = await this.props.fetchApi("get", `/promotions/${this.getIdFromPath()}`);
      const productsResponse = await this.props.fetchApi("get", "/products");

      const promo = promotionResponse.data.promotion;
      const products = productsResponse.data.products;

      const promotionAttributes = promo.attributes || promo;
      const productRelationship = promo.product;

      this.setState({
        name: promotionAttributes.name,
        discountAmount: promotionAttributes.discountAmount,
        startDate: promotionAttributes.startDate,
        endDate: promotionAttributes.endDate,
        status: promotionAttributes.status,
        products: products,
        productId: productRelationship.id,
        originalApplePricePointId: promotionAttributes.originalApplePricePointId,
        applePromotionPricePointId: promotionAttributes.applePromotionPricePointId,
        loading: false,
      });

      const selectedProduct = products.find(p => p.id === productRelationship.id);
      if (selectedProduct) {
        const priceInBRL = selectedProduct.prices.find((price) => price.currency === "BRL");
        const currentPrice = priceInBRL ? priceInBRL.price : null;
        this.setState({ selectedProductPrice: currentPrice });
        this.fetchApplePricePoints(selectedProduct.storeId);
      }

    } catch (err) {
      this.props.showSnackbar("Erro ao carregar dados. Tente novamente.");
      this.setState({ loading: false });
    }
  };

  fetchApplePricePoints = async (sku) => {
    if (!sku) return;
    this.setState({ loading: true, applePricePoints: [] });
    try {
      const response = await this.props.fetchApi("get", `/apple-price-points/${sku}`);
      this.setState({
        applePricePoints: response.data.data,
        loading: false,
      });
    } catch (err) {
      this.props.showSnackbar('Erro ao carregar preços da Apple. Tente novamente.');
      this.setState({ loading: false });
    }
  };

  handleApplePricePointChange = (event) => {
    const pricePointId = event.target.value;
    const selectedPricePoint = this.state.applePricePoints.find(p => p.id === pricePointId);

    if (selectedPricePoint && this.state.selectedProductPrice) {
      const promotionalPrice = parseFloat(selectedPricePoint.attributes.customerPrice);
      const originalPrice = parseFloat(this.state.selectedProductPrice);
      const discount = originalPrice > promotionalPrice ? originalPrice - promotionalPrice : 0;

      this.setState({
        applePromotionPricePointId: pricePointId,
        discountAmount: discount,
      });
    }
  };

  cancelPromotion = async () => {
    this.setState({ loading: true });

    try {
      await this.props.fetchApi("patch", `/promotions/${this.getIdFromPath()}`, {
        data: {
          type: "promotion",
          attributes: {
            status: 4,
          },
        },
      });
      this.props.showSnackbar("Promoção cancelada com sucesso.");
      this.fetchData();
    } catch (err) {
      const errorMsg = _.get(err, "response.data.errors[0].detail", "Erro ao cancelar promoção. Tente novamente.");
      this.props.showSnackbar(errorMsg);
      this.setState({ loading: false });
    }
  };

  updatePromotion = async () => {
    const { name, discountAmount, startDate, endDate, status, applePromotionPricePointId } = this.state;
    const isEditable = status === 0;

    if (!isEditable) {
      this.props.showSnackbar("Apenas promoções agendadas podem ser editadas.");
      return;
    }

    this.setState({ loading: true });

    try {
      await this.props.fetchApi("patch", `/promotions/${this.getIdFromPath()}`, {
        data: {
          type: "promotion",
          attributes: {
            name,
            discountAmount,
            startDate: Moment(startDate).toISOString(),
            endDate: Moment(endDate).toISOString(),
            applePromotionPricePointId,
          },
        },
      });
      this.props.showSnackbar("Promoção salva com sucesso.");
      this.fetchData();
    } catch (err) {
      const errorMsg = _.get(err, "response.data.errors[0].detail", "Erro ao salvar promoção. Tente novamente.");
      this.props.showSnackbar(errorMsg);
      this.setState({ loading: false });
    }
  };

  onChangeField = (field, value) => {
    this.setState({ [field]: value });
  };

  render() {
    const { loading, name, discountAmount, startDate, endDate, status, products, applePricePoints, applePromotionPricePointId, productId } = this.state;
    const isEditable = status === 0;
    const selectedProduct = products.find(p => p.id === productId);

    const statuses = {
      0: "AGENDADA",
      1: "ATIVA",
      2: "CONCLUÍDA",
      3: "CANCELADA",
      4: "AGUARDANDO CANCELAMENTO",
    }

    if (loading) {
      return <CircularProgress style={{ margin: "2rem" }} />;
    }

    return (
      <div>
        <br /><br />
        <Card style={{ padding: "1rem" }}>
          <CardHeader title={`Editar Promoção - ${name}`} />
          <Typography color="textSecondary" gutterBottom>
            ID: {this.getIdFromPath()}
          </Typography>
          <br />
          <form>
            <TextField
              label="Nome da Promoção"
              fullWidth
              value={name}
              onChange={(event) => this.onChangeField("name", event.target.value)}
              disabled={!isEditable}
              style={{ marginBottom: "1rem" }}
            />

            <TextField
              label="Produto"
              fullWidth
              value={selectedProduct ? selectedProduct.name : ''}
              disabled
              style={{ marginBottom: "1rem" }}
            />

            <FormControl fullWidth style={{ marginBottom: "1rem" }} disabled={!productId || !isEditable}>
              <InputLabel>Preço Promocional (Apple)</InputLabel>
              <Select value={applePromotionPricePointId} onChange={this.handleApplePricePointChange}>
                {applePricePoints.map(point => (
                  <MenuItem key={point.id} value={point.id}>
                    R$ {point.attributes.customerPrice}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              label="Valor do Desconto (calculado automaticamente)"
              fullWidth
              type="number"
              value={discountAmount.toFixed(2)}
              disabled
              style={{ marginBottom: "1rem" }}
            />

            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <div style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}>
                <KeyboardDateTimePicker
                  label="Data e Hora de Início"
                  format="DD/MM/YYYY HH:mm"
                  value={startDate}
                  onChange={(date) => this.onChangeField("startDate", date)}
                  disabled={!isEditable}
                  style={{ flex: 1 }}
                />
                <KeyboardDateTimePicker
                  label="Data e Hora de Término"
                  format="DD/MM/YYYY HH:mm"
                  value={endDate}
                  onChange={(date) => this.onChangeField("endDate", date)}
                  disabled={!isEditable}
                  style={{ flex: 1 }}
                />
              </div>
            </MuiPickersUtilsProvider>

            <TextField
              label="Status"
              fullWidth
              value={ statuses[status]}
              disabled
              style={{ marginBottom: "1rem" }}
            />

            <div style={{ marginTop: "20px", display: "flex", gap: "16px" }}>
              <Button
                variant="contained"
                color="primary"
                disabled={!isEditable}
                onClick={this.updatePromotion}
              >
                Salvar Alterações
              </Button>
              <Button
                variant="contained"
                style={status === 2 || status === 3 ||  status === 4 ? {} : { backgroundColor: "#D32F2F", color: "white" }}
                disabled={status === 2 || status === 3 ||  status === 4}
                onClick={this.cancelPromotion}
              >
                Cancelar Promoção
              </Button>
            </div>
          </form>
        </Card>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Promotion.js